
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/how-much-is-a-music-license-for-a-small-shop",
      function () {
        return require("private-next-pages/articles/how-much-is-a-music-license-for-a-small-shop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/how-much-is-a-music-license-for-a-small-shop"])
      });
    }
  